// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"NotFoundPage_NotFoundPage__s0CCt","wrapper":"NotFoundPage_wrapper__wQotf","title":"NotFoundPage_title__bX2EA","message":"NotFoundPage_message__z4gCO"};